module.exports = __webpack_public_path__ + "media/images/profile/basic-info-e482cd1b71f3740f684c41f45d4b9bcf.svg";